import { render, staticRenderFns } from "./ChallengeWeekItem.vue?vue&type=template&id=1676cd7d&scoped=true"
import script from "./ChallengeWeekItem.vue?vue&type=script&lang=js"
export * from "./ChallengeWeekItem.vue?vue&type=script&lang=js"
import style0 from "./ChallengeWeekItem.vue?vue&type=style&index=0&id=1676cd7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1676cd7d",
  null
  
)

export default component.exports